export default "__VITE_ASSET__Ciwgaa8f__"